import React from 'react'
import moment from 'moment'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useActivity } from '@/modules/drivers/stores/activityStore'
import { DateField } from '@/ui/form/controls/DateField'
import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { TimeField } from '@/ui/form/controls/TimeField'

const ActivityRange = () => {
  const { t } = useLocalize()
  const { data, setData } = useActivity()

  const handleStartDateChange = (value: string | null) => {
    if (!value) {
      setData({ ...data, startDate: null })
      return
    }
    const currentTime = data.startDate
      ? data.startDate.format('HH:mm')
      : '00:00'
    const momentDate = moment(`${value} ${currentTime}`, 'YYYY-MM-DD HH:mm')
    setData({ ...data, startDate: momentDate })
  }

  const handleStartTimeChange = (value: string | null) => {
    if (!value) return

    const currentDate = data.startDate
      ? data.startDate.format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD')
    const momentDate = moment(`${currentDate} ${value}`, 'YYYY-MM-DD HH:mm')
    setData({ ...data, startDate: momentDate })
  }

  const handleEndDateChange = (value: string | null) => {
    if (!value) {
      setData({ ...data, endDate: null })
      return
    }
    const currentTime = data.endDate ? data.endDate.format('HH:mm') : '00:00'
    const momentDate = moment(`${value} ${currentTime}`, 'YYYY-MM-DD HH:mm')
    setData({ ...data, endDate: momentDate })
  }

  const handleEndTimeChange = (value: string | null) => {
    if (!value) return

    const currentDate = data.endDate
      ? data.endDate.format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD')
    const momentDate = moment(`${currentDate} ${value}`, 'YYYY-MM-DD HH:mm')
    setData({ ...data, endDate: momentDate })
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-space-y-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            {t('activities.activity-start')}
          </p>
        </div>
        {/* <DateAndMonthField
          label="Data"
          value={data.startDate ? data.startDate.format('YYYY-MM-DD') : null}
          setValue={handleStartDateChange}
        /> */}
        <div className="tw-jusitfy-end tw-flex tw-flex-1 tw-gap-2">
          <DateField
            label="Data"
            value={data.startDate ? data.startDate.format('YYYY-MM-DD') : null}
            setValue={handleStartDateChange}
          />
          <TimeField
            label="Godzina"
            value={data.startDate ? data.startDate.format('HH:mm') : null}
            setValue={handleStartTimeChange}
          />
        </div>
      </div>
      <DividerHorizontal />
      <div className="tw-space-y-2">
        <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            {t('activities.activity-end')}
          </p>
        </div>
        <div className="tw-flex tw-flex-1 tw-gap-2">
          <DateField
            label="Data"
            value={data.endDate ? data.endDate.format('YYYY-MM-DD') : null}
            setValue={handleEndDateChange}
          />
          <TimeField
            label="Godzina"
            value={data.endDate ? data.endDate.format('HH:mm') : null}
            setValue={handleEndTimeChange}
          />
        </div>
      </div>
    </div>
  )
}

export default ActivityRange
